import React from 'react';
import styled from '@emotion/styled';
import { Css, ITheme } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { Color } from '../../../../../shared/styles/Color';
import themed from '../../../../../../ui/themer/themed';

interface IBookingSummaryHeaderProps {
	button?: {
		label: string;
		onClick: (ev: React.MouseEvent) => void;
	};
}

export const BookingSummaryHeader = ({
	button,
}: IBookingSummaryHeaderProps) => {
	const { t } = useTranslation();

	return (
		<StyledBookingSummaryHeader>
			{t('web_parking_booking_summary_header')}

			{button && (
				<StyledButton type="button" onClick={button.onClick}>
					{button.label}
				</StyledButton>
			)}
		</StyledBookingSummaryHeader>
	);
};

export const StyledBookingSummaryHeader = styled.h3<{}, ITheme>`
	border-bottom: ${themed(({ border }) => border.default)};
	padding-bottom: 16px;
	margin-bottom: 0;
	display: flex;
`;

const StyledButton = styled.button`
	font-family: inherit;
	background: none;
	border: none;
	background: transparent;
	margin-left: auto;
	font-size: ${Css.pxToRem(16)};
	font-weight: 500;
	color: ${Color.PrimaryDark};
	padding: 0 2px;

	&:focus-visible {
		outline: 3px solid ${Color.PrimaryDark};
		border-radius: 4px;
	}
`;
